import React, { useEffect, useState, Fragment } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage/StandardPage'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiResponse } from '../../typings/ApiResponse'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'
import { usePagination } from '../../hooks/usePagination'
import { GenericTableV2 } from '../../components/_EOS/GenericTable'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import { ProcessEntity } from './Types/entities'
import { getProcessList, getUrlOriginalFile, getUrlResultFileUrl } from './api'
import { useSnackbar } from '../../hooks/useSnackbar'
import { ProcessSearch } from '../../components/ProcessNew/ProcessSearch'
import {
  downloadBase64File,
  getColumnsConfig,
  getDefaultDateRangeFilters
} from './config/config'

interface ProductPageProps {}

export const ProcessNew: React.FC<ProductPageProps> = () => {
  const { state, callApi, setIdle } = useApi<ApiResponse<ProcessEntity>>()
  const { callApi: callApiGetResultFile } = useApi<ApiResponse<ProcessEntity>>()
  const { callApi: callApiGetOriginalUrlFile } =
    useApi<ApiResponse<ProcessEntity>>()
  const { isActive, isSuccess, message } = useSnackbar()
  const [selectedFilters, setSelectedFilters] = useState<Filter[]>(
    getDefaultDateRangeFilters()
  )
  const [loadingForm, setloadingForm] = useState(false)
  const pagination = usePagination(5)

  const requestProcess = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    callApi(getProcessList(filters, page, pageSize)).catch((error) => {
      console.log(error)
    })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestProcess(selectedFilters, auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }


  const resetAndFetchData = (filters?: Filter[]) => {
    pagination.setPagination(0, pagination.pageSize)
    requestProcess(filters, 0, pagination.pageSize)
  }

  const handleFilterChange = (value: React.SetStateAction<Filter[]>) => {
    const newFilters =
      typeof value === 'function' ? value(selectedFilters) : value

    const isDeletion = newFilters.length < selectedFilters.length

    setSelectedFilters(newFilters)

    if (isDeletion) {
      if (newFilters.length > 0) {
        // Aún queda al menos un filtro: re-consultar con los filtros restantes
        resetAndFetchData(newFilters)
      } else {
        // Se eliminó el último filtro: limpiar la grilla sin consultar
        pagination.setPagination(0, pagination.pageSize)
        setIdle()
      }
    }
  }

  const handleDownloadResultFile = (processId: number) => {
    callApiGetResultFile(getUrlResultFileUrl(processId))   // <- nuevo endpoint
      .then((data) => {
        const a = document.createElement('a')
        a.href = data.url          // la SAS URL
        a.download = data.name     // nombre sugerido del archivo
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
      .catch((error) => console.log(error))
  }

  const handleDownloadOriginalFile = (processId: number) => {
    callApiGetOriginalUrlFile(getUrlOriginalFile(processId))
      .then((data) => {
        downloadBase64File(data.file, data.name, data.mimeType)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    // Solo se busca automáticamente en la carga inicial (con el rango de
    // fechas por defecto); al agregar/quitar filtros debe esperar a que
    // se presione "Buscar"
    setloadingForm(true)
    resetAndFetchData(selectedFilters)
    setloadingForm(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columnsConfig = getColumnsConfig()
  return (
    <Fragment>
      <StandardPage pageTitle=''>
        <ProcessSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={handleFilterChange}
          onSearchClick={resetAndFetchData}
          includeAddButton={true}
        />

        <GenericTableV2<ProcessEntity>
          data={state.data?.items || []}
          columns={columnsConfig}
          keyField='processId'
          loading={state.status === Status.Loading || loadingForm}
          pagination={{
            total: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize,
            onPageChange: handlePaginationChange
          }}
          actions={[
            {
              key: 'originalFile',
              label: 'Archivo Original',
              icon: <FileDownloadOutlinedIcon />,
              disabled: (row) => !row.fileName,
              onClick: (row) => handleDownloadOriginalFile(row.processId)
            },
            {
              key: 'resultFile',
              label: 'Resultado Carga',
              icon: <FactCheckOutlinedIcon />,
              disabled: (row) => !row.urlFileResulting,
              onClick: (row) => handleDownloadResultFile(row.processId)
            }
          ]}
        />
      </StandardPage>
      <SnackBar
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
        message={message}
      />
    </Fragment>
  )
}
